export default {
  COOKIE: {
    PCID: "PCID",
    MEMBERSRL: "member_srl",
    ISAPP: "ISAPP",
    CAMPAIGN: [
      "trac_src", "trac_spec", "trac_sid", "trac_lptag", "trac_itime", "trac_ctag", "trac_appver", "trac_addtag",
    ],
  }
}